import IndexPage from './components/IndexPage';
import DiscussionPage from './components/DiscussionPage';
import PostsUserPage from './components/PostsUserPage';
import DiscussionPageResolver from './resolvers/DiscussionPageResolver';
import UserPageResolver from './resolvers/UserPageResolver';

/**
 * Helper functions to generate URLs to form pages.
 */

/**
 * The `routes` initializer defines the forum app's routes.
 */
export default function (app) {
  app.routes = {
    index: {
      path: '/all',
      component: IndexPage
    },
    posts: {
      path: '/posts',
      component: () => import(/* webpackChunkName: 'forum/components/PostsPage', webpackMode: 'lazy-once' */ './components/PostsPage')
    },
    discussion: {
      path: '/d/:id',
      component: DiscussionPage,
      resolverClass: DiscussionPageResolver
    },
    'discussion.near': {
      path: '/d/:id/:near',
      component: DiscussionPage,
      resolverClass: DiscussionPageResolver
    },
    user: {
      path: '/u/:username',
      component: PostsUserPage,
      resolverClass: UserPageResolver
    },
    'user.posts': {
      path: '/u/:username',
      component: PostsUserPage,
      resolverClass: UserPageResolver
    },
    'user.discussions': {
      path: '/u/:username/discussions',
      component: () => import(/* webpackChunkName: 'forum/components/DiscussionsUserPage', webpackMode: 'lazy-once' */ './components/DiscussionsUserPage'),
      resolverClass: UserPageResolver
    },
    settings: {
      path: '/settings',
      component: () => import(/* webpackChunkName: 'forum/components/SettingsPage', webpackMode: 'lazy-once' */ './components/SettingsPage')
    },
    'user.security': {
      path: '/u/:username/security',
      component: () => import(/* webpackChunkName: 'forum/components/UserSecurityPage', webpackMode: 'lazy-once' */ './components/UserSecurityPage'),
      resolverClass: UserPageResolver
    },
    notifications: {
      path: '/notifications',
      component: () => import(/* webpackChunkName: 'forum/components/NotificationsPage', webpackMode: 'lazy-once' */ './components/NotificationsPage')
    }
  };
}
export function makeRouteHelpers(app) {
  return {
    /**
     * Generate a URL to a discussion.
     */
    discussion: (discussion, near) => {
      return app.route(near && near !== 1 ? 'discussion.near' : 'discussion', {
        id: discussion.slug(),
        near: near && near !== 1 ? near : undefined
      });
    },
    /**
     * Generate a URL to a post.
     */
    post: post => {
      return app.route.discussion(post.discussion(), post.number());
    },
    /**
     * Generate a URL to a user.
     */
    user: user => {
      return app.route('user', {
        username: user.slug()
      });
    }
  };
}flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/PostsPage');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/app');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/app');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/utils/History');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/setRouteWithForcedRefresh');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/utils/Pane');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/DiscussionPage');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Page');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/Component');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/states/PageState');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/subclassOf');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/ItemList');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/isObject');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/DiscussionHero');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/Hero');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/listItems');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Separator');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/DiscussionListPane');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/DiscussionList');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/DiscussionListItem');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Link');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/extract');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/highlight');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/string');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/humanTime');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/abbreviateNumber');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/extractText');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Dropdown');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Tooltip');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Icon');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/TerminalPost');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/humanTime');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/SubtreeRetainer');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/utils/DiscussionControls');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Button');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/fireDebugWarning');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/LoadingIndicator');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/RenameDiscussionModal');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/FormModal');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Modal');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Alert');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/Stream');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Form');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/haptic');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/utils/slidable');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/escapeRegExp');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Avatar');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Placeholder');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/a11y');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/SplitDropdown');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/states/PostStreamState');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/anchorScroll');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/PageStructure');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/HeaderPrimary');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/HeaderSecondary');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/SessionDropdown');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/username');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/LinkButton');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/SelectDropdown');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/models/Discussion');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/Model');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/computed');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Badge');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/textContrastClass');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/isDark');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/GlobalDiscussionsSearchSource');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/MinimalDiscussionListItem');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/GlobalUsersSearchSource');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/UserSearchResult');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Input');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/DiscussionRenamedNotification');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/utils/PostControls');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/PostUser');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/userOnline');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/PostMeta');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/fullTime');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/IPAddress');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/models/Post');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/PostEdited');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/UserCard');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/utils/UserControls');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/UserPage');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/AffixedSidebar');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/AvatarEditor');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/ComposerPostPreview');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/DiscussionRenamedPost');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/EventPost');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/routes');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/IndexPage');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/WelcomeHero');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/IndexSidebar');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/states/PostListState');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/states/PaginatedListState');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/EventEmitter');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/PostsUserPage');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/resolvers/DiscussionPageResolver');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/resolvers/DefaultResolver');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/resolvers/UserPageResolver');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/AlertManager');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/RequestErrorModal');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/Translator');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/Drawer');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/mapRoutes');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/RequestError');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/ScrollListener');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extend');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/models/Forum');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/models/User');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/stringToColor');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/GroupBadge');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/models/Group');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/models/Notification');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/states/ModalManagerState');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/states/AlertManagerState');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/ThemeMode');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Navigation');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/states/NotificationListState');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/states/GlobalSearchState');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/states/SearchState');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/states/DiscussionListState');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/states/ComposerState');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/query/IGambit');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/AutocompleteReader');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/GambitsAutocomplete');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/insertText');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/sortGroups');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/formatNumber');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/withAttr');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/KeyboardNavigatable');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Switch');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Checkbox');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/InfoTile');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/FieldSet');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/LabelValue');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/TextEditor');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/BasicEditorDriver');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/LoadingPost');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/LogInButtons');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/index');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/index');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/registry');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/patchMithril');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/common');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/forum');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/ExportRegistry');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/LogInButton');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/PostPreview');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/Search');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extenders/index');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/mixin');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/styleSelectedText');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/throttleDebounce');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/UserSelectionModal');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/formatAmount');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/generateElementId');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/FormGroup');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/DetailedDropdownItem');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Select');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/MultiSelect');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/ColorPreviewInput');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/TextEditorButton');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/AutocompleteDropdown');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/GambitsAutocompleteDropdown');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/UploadImageButton');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/punctuateSeries');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/Fragment');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/bidi');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/DiscussionsSearchSource');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/UsersSearchSource');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extenders/Model');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extenders/PostTypes');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extenders/Routes');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extenders/Store');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extenders/Search');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extenders/Notification');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extenders/ThemeMode');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/extenders/Admin');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/Pill');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/DiscussionsSearchItem');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/SearchManager');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/GambitManager');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/query/discussions/AuthorGambit');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/query/discussions/CreatedGambit');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/query/discussions/HiddenGambit');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/query/discussions/UnreadGambit');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/query/users/EmailGambit');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/query/users/GroupGambit');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/query/discussions/DiscussionGambit');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/Application');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/Store');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/Session');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/liveHumanTimes');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/helpers/fireApplicationError');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/models/AccessToken');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/ForumApplication');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/utils/isSafariMobile');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/Notices');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/Footer');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/NotificationList');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/HeaderList');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/HeaderListGroup');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/NotificationType');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/GlobalSearch');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/GlobalPostsSearchSource');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/AbstractGlobalSearch');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/focusTrap');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/Notification');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/HeaderListItem');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/Post');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/AbstractPost');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/NotificationsDropdown');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/HeaderDropdown');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/CommentPost');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/Comment');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/utils/classList');
flarum.reg.addChunkModule('170', '8510', 'core', 'common/components/ModalManager');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/PostList');
flarum.reg.addChunkModule('170', '8510', 'core', 'forum/components/PostListItem');
flarum.reg.addChunkModule('879', '9101', 'core', 'forum/components/DiscussionsUserPage');
flarum.reg.addChunkModule('298', '1612', 'core', 'forum/components/SettingsPage');
flarum.reg.addChunkModule('298', '1612', 'core', 'forum/components/NotificationGrid');
flarum.reg.addChunkModule('298', '1612', 'core', 'forum/components/ChangePasswordModal');
flarum.reg.addChunkModule('298', '1612', 'core', 'forum/components/ChangeEmailModal');
flarum.reg.addChunkModule('698', '7017', 'core', 'forum/components/UserSecurityPage');
flarum.reg.addChunkModule('698', '7017', 'core', 'forum/components/AccessTokensList');
flarum.reg.addChunkModule('698', '7017', 'core', 'forum/components/NewAccessTokenModal');
flarum.reg.addChunkModule('698', '7017', 'core', 'forum/states/UserSecurityPageState');
flarum.reg.addChunkModule('173', '8427', 'core', 'forum/components/NotificationsPage');